const getItem = (array, name) => {
    const arrayItem = array.filter((item) => item.name === name);
    if (arrayItem.length > 0) {
        return arrayItem[0];
    }
    return {
        amount: 0,
        display: true,
        value: 0,
    };
};

const getTotal = (items) => {
    const total = { cost: 0, cpor: 0 };
    items.forEach((item) => {
        total.cost = item.amount !== 'NaN' ? total.cost + parseFloat(item.amount) : total.cost;
        total.cpor = item.cpor !== 'NaN' ? total.cpor + parseFloat(item.cpor) : total.cpor;
    });
    return total;
};

const getTotalCpor = (formData) => {
    const cporAmounts = Object.values(formData.cpor);
    let totalCpor = 0;
    cporAmounts.forEach((amount) => {
        totalCpor += amount;
    });
    return totalCpor.toFixed(2);
};

const getTotalRow = (item, name) => {
    const total = getTotal(item);
    return ['Overall Totals', name, '', '', !Number.isNaN(total.cost) ? total.cost.toFixed(2) : 0];
};

const getCSVData = (formData) => {
    const rows = [
        ['Section', 'Field', 'Period Total', '% Assigned', 'Total'],
        ['Room Breakdown', 'Total Number of rooms', '', '', formData.roomBreakdown.numberOfRooms],
        ['Room Breakdown', 'Days open per period', '', '', formData.roomBreakdown.daysOpenPerPeriod],
        ['Room Breakdown', 'Average Occupancy %', '', '', formData.roomBreakdown.averageOccupancy],
    ];
    formData.roomConsumables.forEach((item) => rows.push(['Room Consumables', item.name, '', '', item.value]));
    formData.fixedCosts.forEach((item) =>
        rows.push(['Fixed Costs', item.name, item.value, item.percentage, item.amount]),
    );
    formData.salaryCosts.forEach((item) =>
        rows.push(['Salary Costs', item.name, item.value, item.percentage, item.amount]),
    );
    formData.commission.forEach((item) => rows.push(['Commission Paid', item.name, '', '', item.value]));
    formData.variables.forEach((item) => rows.push(['Variables', item.name, item.value, item.percentage, item.amount]));
    rows.push(getTotalRow(formData.roomConsumables, 'Room Consumables'));
    rows.push(getTotalRow(formData.fixedCosts, 'Fixed Costs'));
    rows.push(getTotalRow(formData.salaryCosts, 'Salary Costs'));
    rows.push(getTotalRow(formData.commission, 'Commission Paid'));
    rows.push(getTotalRow(formData.variables, 'Variables'));

    rows.push(['Overall Totals', 'Cost of Occupied Room', '', '', getTotalCpor(formData)]);
    return rows;
};

export { getItem, getTotal, getCSVData, getTotalCpor };
